import React from "react";

import Checkbox from "@material-ui/core/Checkbox";
import { makeStyles, useTheme } from "@material-ui/core/styles";

import FormControl from "@material-ui/core/FormControl";
// import Paper from "@material-ui/core/Paper";
import cache from "memory-cache";
import { FormControlLabel, FormGroup, Popover, Typography } from "@material-ui/core";
import { WEB_URL } from "../../../utils/constants";
import onWindowReload from '../../../utils/reloadFunction';
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
 paper: {
      padding:'0px 5px',
    },
  popover: {
    pointerEvents: "none",
  },
}));

//   const CheckboxGroup = ({ fields, options }) => {
//     const toggle = (event, option) => {
//       if (event.target.checked) fields.push(option);
//       else fields.remove(option);
//     };
//     return (
//       <div style={{ color: "blue" }}>
//         {options.map(option => (
//           <div key={option}>
//             <input
//               type="checkbox"
//               onClick={event => toggle(event, option)}
//             />
//             {option}
//           </div>
//         ))}
//       </div>
//     );
//   };

export default (props) => {
  const classes = useStyles();

  const {
    testData,
    questionNo,
    setClearFlag,
    clearFlag,
    examId,
    setCheckFlag,
    examDetail,
    answerStatus,
    setAnswerStatus,
    disable,
    setDisable,
    setTestData,
    windowSwitchCount,setWindowSwitch
  } = props;
  const [selectAnswer, setAnswer] = React.useState("");
  const opt = [];
  const [myOptions, setMyOptions] = React.useState(
    testData[questionNo - 1].selectedChoiceId.match(/\d+/g)
      ? testData[questionNo - 1].choiceid.replace("|^^|", ",")
      : ""
  ); //testData[questionNo -1].selectedChoiceId
  const [checkArray, setCheckArray] = React.useState(
    testData[questionNo - 1].selectedChoiceId
  );
  // const myOptions = testData[questionNo -1].choiceid.replace('|^^|',',');
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  onWindowReload(examId,examDetail,setWindowSwitch,setTestData,windowSwitchCount,testData)


  const open = Boolean(anchorEl);

  const getAnswer = (values) => {
    
    //testData[questionNo -1].choiceid.split('|^^|')[testData[questionNo -1].choicetext.split('|^^|').indexOf(event.target.value)] ;
    if (testData[questionNo - 1].selectedChoiceId.match(/\d+/g)) {
      //  setAnswer(testData[questionNo -1].selectedChoiceId);
      if (testData[questionNo - 1].selectedChoiceId.indexOf("null") == -1) {
        testData[questionNo - 1].buttonStyle = "Answered";
      }
    }
    
  };

  const CheckboxGroupMUI = () => {

    if (testData[questionNo - 1].selectedChoiceId == "") {
      let data = checkArray.split(","); 
      while (data.length > 0) {
        data.pop();
      }
    }

    const toggle = (event, choiceid) => {
      let fields = testData[questionNo - 1].selectedChoiceId.split(",");
      
      if (event.target.checked) {
        fields.push(choiceid);
      } else {
        fields.splice(fields.indexOf(choiceid), 1)
      }

    
      // let arr = fields;
      // fields.map((item) => {
      //   if(checkArray.indexOf(testData[questionNo - 1].choiceid.split("|^^|")[
      //     testData[questionNo - 1].choicetext.split("|^^|").indexOf(item)
      //   ]) == -1) {
      //     arr.push(
      //       testData[questionNo - 1].choiceid.split("|^^|")[
      //         testData[questionNo - 1].choicetext.split("|^^|").indexOf(item)
      //       ]
      //     );
      //   }
      // });

      
      setClearFlag(false);
      // setAnswer(arr);

      testData[questionNo - 1].selectedChoiceId = fields.toString();
      setCheckArray(fields.toString());
    };

    //   const check = (event, option) => {
    //     
    //   if (event.target.checked) {
    //       fields.push(option);
    //     }
    //     else if(testData[questionNo -1].selectedChoiceId.match(/\d+/g)){
    //       fields.push
    //     }
    //   else{
    //     fields.remove(option);
    //   }
    // };

    //  testData[questionNo -1].selectedChoiceId.split(',').indexOf(testData[questionNo -1].choiceid.split('|^^|')[index]) !== -1
    getAnswer(checkArray);
    return (
      <FormGroup row={false}>
        {testData[questionNo - 1].choicetext
          .split("|^^|")
          .map((item, index) => (
            <FormControlLabel
              key={item}
              //label={<span dangerouslySetInnerHTML={{__html: item}} style={{color:testData[questionNo -1].choicetext.split('|^^|')[testData[questionNo -1].choiceid.split('|^^|').indexOf(testData[questionNo -1].selectedChoiceId)] === item  ? "#fff" : "#525252" }} />}
                            
              label={<span dangerouslySetInnerHTML={{ __html: item }} />}
              control={
                <Checkbox
                  value={item}
                  onChange={(event) => toggle(event,  testData[questionNo - 1].choiceid.split("|^^|")[index])}
                  //checked = {testData[questionNo -1].selectedChoiceId.split(',')[testData[questionNo -1].choicetext] !=='' ?testData[questionNo -1].selectedChoiceId.split(',')[testData[questionNo -1].choicetext.split('|^^|')].indexOf(item):false}
                  checked={
                    testData[questionNo - 1].selectedChoiceId
                          .split(",")
                          .indexOf(
                            testData[questionNo - 1].choiceid.split("|^^|")[index]
                          ) !== -1
                     
                  }
                />
              }
            />
          ))}
      </FormGroup>
    );
  };
  React.useEffect(() => {
    
    if (questionNo === testData.length) {
     

      setDisable(true);
    }
    

    if (clearFlag) {
      testData[questionNo - 1].selectedChoiceId = "";
      setAnswer("");
      setMyOptions("");
      setCheckArray("");
      let temp = answerStatus;
      //temp[questionNo -1] = 0;
      setAnswerStatus(temp);
      testData[questionNo - 1].buttonStyle = "Not Answered";
      
      let collectData = {quesData: testData, examDetail: examDetail}
      let encode = encodeURIComponent(btoa(encodeURIComponent(JSON.stringify(collectData))))
      window.localStorage.setItem(examId, encode);
      
      setClearFlag(false);
    }
    let collectData = {quesData: testData, examDetail: examDetail}
    let encode = encodeURIComponent(btoa(encodeURIComponent(JSON.stringify(collectData))))
    window.localStorage.setItem(examId, encode);
  }, [
    clearFlag,
    myOptions,
    selectAnswer,
    questionNo,
    answerStatus,
    checkArray,
  ]);

 
  return (
    <div>
      <>
        {/* <strong> Question No {questionNo}</strong>< br/>  */}
        <Typography
          aria-owns={open ? "mouse-over-popover" : undefined}
          aria-haspopup="true"
          onMouseEnter={handlePopoverOpen}
          onMouseLeave={handlePopoverClose}
        >
          <span className="question-num">Q .{questionNo} of {testData.length}</span>
        </Typography>
        {/* <Button> Question No {questionNo}</Button>< br/>  */}
        <Popover
          id="mouse-over-popover"
          className={classes.popover}
          classes={{
            paper: classes.paper,
          }}
          open={open}
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: "center",
            horizontal: "left",
          }}
          PaperProps={{
            style: { height: '4%' ,textAlign:"center"},
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          onClose={handlePopoverClose}
          disableRestoreFocus
        >
          <Typography>{testData[questionNo - 1].qid}</Typography>
        </Popover>
        {/* {testData[questionNo -1].qtext} */}
        <span style={{fontSize:"16px"}} 
          dangerouslySetInnerHTML={{ __html: testData[questionNo - 1].qtext }}
        />
        {testData[questionNo - 1].qresourcepath !== "" ? (
          <>
            {" "}
            <br />
             <img
              src={
                `${WEB_URL}ah-resources/questionimages/` +
                testData[questionNo - 1].qresourcepath.split("|^^|")[0]
              }
            />
          </>
        ) : (
          <></>
        )}
        <br />
        <FormControl component="fieldset">
          <CheckboxGroupMUI />
        </FormControl>
      </>
    </div>
  );
};
